import { SelectableThemes, type HostType } from 'configs/theme'
import { c, FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { useRouter } from 'next/router'

const themeCookieName = 'theme'
const cookieMaxAge = 365 * 24 * 60 * 60

const ThemePicker: FC = () => {
  const { theme: currentTheme } = useUserContext()
  const router = useRouter()

  const selectTheme = (hostType: HostType) => {
    document.cookie = `${themeCookieName}=${hostType}; Max-Age=${cookieMaxAge}; Path=/; SameSite=Lax`

    router.reload()
  }

  const renderTheme = ({
    title,
    subtitle,
    logo,
    id,
    active,
    onClick,
  }: {
    title: string
    subtitle: string
    logo: string
    id: string
    active: boolean
    onClick: () => void
  }) => (
    <button key={id} type="button" onClick={onClick} className="group px-2 py-0.5 text-gray-700">
      <div
        className={c`relative grow rounded-lg flex items-center px-3 py-2.5 gap-2.5 ${active} bg-primary-100 group-hover:bg-primary-200 | group-hover:bg-gray-100`}
      >
        <div className="flex size-6 shrink-0 items-center justify-center">
          <img src={logo} className="relative size-6 object-contain" alt={`${title} logo`} />
        </div>
        <div className="flex min-w-0 flex-col text-left">
          <span className="truncate text-sm font-medium">{title}</span>
          <span className="truncate text-[11px] leading-3 font-mono">{subtitle}</span>
        </div>
      </div>
    </button>
  )

  return (
    <div className="px-2 py-0.5 flex flex-col">
      {SelectableThemes.map((theme) =>
        renderTheme({
          title: theme.title,
          subtitle: theme.hostType,
          logo: theme.logoFixed || theme.logoDark,
          id: theme.hostType,
          active: currentTheme.hostType === theme.hostType,
          onClick: () => selectTheme(theme.hostType),
        })
      )}
    </div>
  )
}

export default ThemePicker
